// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__A5sik","header":"CardSellers_header__oRKea","photo":"CardSellers_photo__WACnr","name":"CardSellers_name__TNzwl","details":"CardSellers_details__+PIud"};